import { Pipe, PipeTransform } from "@angular/core";
import {SistemaService} from '../Servicios/Sistema.Service';

@Pipe(
  {
    name: 'filtro',
    pure: true
  })

export class FiltroPipe implements PipeTransform
{
  constructor( public sistemaService : SistemaService)
  {
  }

  transform(items : any, buscar : any,  atributosbuscar : Array<any>)
  {
    if (!items || buscar === '' || buscar == null || buscar == undefined)
    {
      return items;
    }

    let isTexto = typeof buscar === 'string';


    if(isTexto)
    {
      buscar = this.sistemaService.RemoveAcentos(buscar.toLowerCase());
    }

    let buscarsinSignos = isTexto ? buscar.replace(/[^a-zA-z0-9ñÑ\s]/ig, '').replace(/(\[*)(\^*)(\]*)(\\*)/g, '').replace(/\s+$/, '') : null;

    let atributos : Array<any> = [];

    atributosbuscar.forEach( (p:any) =>
    {
      atributos.push(p.split('.'));
    })


    return items.filter((item : any) =>
    {

      for(let i = 0; i<atributos.length; i++)
      {

        let itemaux = item[atributos[i][0]];

        for (let k = 1; k < atributos[i].length; k++)
        {
          itemaux = itemaux[atributos[i][k]];
        }

        if(!itemaux)
        {
          return false;
        }

        if(isTexto)
        {
          let texto = this.sistemaService.RemoveAcentos(itemaux.toLowerCase());
          texto = texto.replace(/[^a-zA-z0-9ñÑ\s]/g, "");

          let regex = new RegExp("^" + buscar + "|\\s"+buscar);
          let index = texto.match(regex);

          if (index === null)
          {
            let ultimoindex = texto.lastIndexOf(buscarsinSignos);

            if (ultimoindex >= 0)
            {
              return true;
            }
            {
              continue;
            }
          }
          else
          {
            return true;
          }
        }
        else
        {
          if(itemaux == buscar)
          {
            return true;
          }
          else
          {
            continue;
          }
        }

      }

      return false;
    });
  }

}
